export default __webpack_public_path__ + "static/media/budha.caa4c365.png";